import { useQuery } from '@tanstack/react-query';
import { profileService } from '../api/profile.service';
import { PROFILE_KEYS } from './queryKeys';

/**
 * Obtiene el perfil del usuario autenticado desde la API.
 *
 * @returns Query result con `data` (ProfileResponse), `isLoading`, `isError`
 *
 * @remarks
 * staleTime de 300s — el perfil cambia raramente.
 * No requiere `activeOrganizationId` — el perfil es user-scoped.
 */
export function useProfile() {
  return useQuery({
    queryKey: PROFILE_KEYS.me(),
    queryFn: ({ signal }) => profileService.getProfile(signal).then((r) => r.data),
    staleTime: 300_000,
  });
}
